<template lang="pug">
.Cart(:class="open ? 'open' : ''")
  .header(@click="closeCart")
    h1.titulo Maria ©erdan
    .total
      img.x2(src="@/assets/images/x2.png")
    // .total
      span {{ invitaBirra ? 0 : cartContent.length }}
      svg.cart-icon(xmlns='http://www.w3.org/2000/svg', viewBox='0 0 59.293 42.052')
        path(d='M28.38 37.552a4.5 4.5 0 11-4.5-4.5 4.5 4.5 0 014.5 4.5')
        path(d='M50.38 37.552a4.5 4.5 0 11-4.5-4.5 4.5 4.5 0 014.5 4.5')
        path(d='M51.184 28.52H19.1L13.332 5.846H2.62A2.639 2.639 0 010 3.189 2.639 2.639 0 012.62.532h15.31l5.763 22.674h23.8l6.585-20.913a2.621 2.621 0 115.19.728z')
  .body(v-chat-scroll)
    ul.items(v-if="invitaBirra" ): li.item
      p.beer Cerveza/Bier
      p x1
    ul.items(v-else): li.item(v-for="item in cartContent" v-if="typeof item.text === 'string'")
      p {{ item.text.replace(/[¿?,.!… ]/g, '') }}
      p x1
  .checkout
    .total
      strong Total
      strong {{ invitaBirra ? 1 : cartContent.length }}
    a(:class="{ 'hitMe' : !invitaBirra}" @click="addToCart" :href="!invitaBirra ? '#' : url"): span.hitMeText {{ !invitaBirra ? hitMeText : checkoutText}}

  footer
    // p: strong María Cerdán Copywriter
    p: a(href="mailto:hi@mariacerdan.com") hi@mariacerdan.com
    p: a(href="tel:+34617470841") +34 617 470 841
    .links
      a.ig(href="https://instagram.com/mariacerdan" target="_blank"): font-awesome-icon(:icon="['fab', 'instagram']")
      a.yt(href="https://vimeo.com/user103999587" target="_blank"): font-awesome-icon(:icon="['fab', 'vimeo-v']")
      a.ln(href="https://es.linkedin.com/in/mar%C3%ADa-cerd%C3%A1n-mart%C3%ADnez-baa33163" target="_blank"): font-awesome-icon(:icon="['fab', 'linkedin']")
      a.yt(href="https://youtube.com/channel/UC4zPRduzvsrt_luQS-G8tzw" target="_blank"): font-awesome-icon(:icon="['fab', 'youtube']")
  .background(@click="closeCart")
</template>

<script src="https://cdn.jsdelivr.net/npm/vue-chat-scroll/dist/vue-chat-scroll.min.js"></script>

<script>
import Logo from '@/components/Logo'

export default {
  name: 'Cart',
  components: { Logo },
  data() {
    return {
      hitMeText: 'Hit me!',
      checkoutText: 'Check me out!',
      cartContent: [],
      open: false,
      email: {
        address: 'hi@mariacerdan.com',
        subject: 'Hey! You owe me a BEER!',
        body: ''
      },
      url: '#'
    }
  },
  methods: {
    closeCart() {
      this.$store.commit('openCart', false)
    },
    addToCart() {
      this.$root.$emit('addToCart')
      if (this.invitaBirra) {
        this.url = encodeURI(
          `mailto:${this.email.address}?subject=${this.email.subject}&body=${this.email.body}`
        )
      }
    }
  },
  computed: {
    cart() {
      return this.$store.state.words.filter(
        word => word.inCart && word.style !== 'image'
      )
    },
    cartIsOpen() {
      return this.$store.state.cartIsOpen
    },
    invitaBirra() {
      return this.cartContent.filter(item => item.style === 'birra').length > 0
    }
  },
  watch: {
    cartIsOpen(newState, oldState) {
      this.open = newState
    },
    cart(newCart, oldCart) {
      this.cartContent = newCart
    }
  }
}
</script>

<style lang="scss">
.x2 {
  width: 30px;
  margin-right: -0.5em;

  -webkit-transition: -webkit-transform 0.3s ease-in-out;
  transition: transform 0.3s ease-in-out;
}

.x2:hover {
  -webkit-transform: rotate(-180deg);
  transform: rotate(-180deg);
}

.Cart {
  position: fixed;
  right: 0;
  display: grid;
  grid-template-rows: auto 1fr;
  height: 100vh;
  min-width: 20rem;
  max-width: 90vh;
  box-shadow: 0 0 0 calc(100vw + 100vh) rgba(#000, 0);
  z-index: 14;
  &.open {
    background-color: $c-set-secondbg;
    box-shadow: 0 0 0 calc(100vw + 100vh) rgba(#000, 0.3);
  }

  > * {
    padding: 0 $margins-d;
  }

  .background {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 90;
  }

  .header {
    display: flex;
    justify-content: space-between;
    padding: $margins-d;
    padding-top: 2em;
    padding-bottom: 2em;
    align-items: center;
    color: white;
    background: black;
    cursor: pointer;
    font-size: $fs-xs;
    z-index: 99;

    .Logo {
      margin: 0;
      padding: 0;
    }

    .total {
      display: inline-block;
      // margin: 0.25rem 0;
      border-radius: 0.5rem;
      // padding: 0.3rem 1rem;
      font-variant-numeric: tabular-nums;
      border: none;
      // line-height: 2;

      span {
        opacity: 0.5;
        font-weight: bold;
      }

      .cart-icon {
        fill: black;
        margin-left: 0.6rem;
        vertical-align: -0.1rem;
        width: 1.1em;
        transform: scale(2);
        transform-origin: left;
      }
    }
  }

  .body {
    background-color: white;
    z-index: 99;
    display: grid;
    grid-template-rows: 1fr auto;
    overflow-y: scroll;
    border-top: 0.7rem solid white;
    /*  border-bottom: 0.7rem solid $c-set-secondbg; */

    .items {
      padding: 0;
      list-style: none;
      margin: 0;

      .item {
        display: flex;
        justify-content: space-between;
        margin: 1rem 0;

        .beer {
          color: #black;
        }

        p {
          margin: 0;
          font-weight: bold;
        }
      }
    }
  }

  .checkout {
    padding-bottom: $margins-d;
    background-color: white;
    font-weight: bold;
    z-index: 9999;
    padding-top: 0.5rem;

    .total {
      display: flex;
      justify-content: space-between;
      padding: 1rem 0;
      border-top: 2px solid black;
      margin: 0;

      p {
        margin: 0;
      }
    }

    > a {
      cursor: pointer;
      text-align: center;
      display: block;
      background: white;
      border: solid 2px black;
      color: black;
      padding: 0.5em 1em;
      border-radius: 0.5em;
      text-decoration: none;

      ::selection {
        background: #ffb7b7; /* WebKit/Blink Browsers */
      }
      ::-moz-selection {
        background: #ffb7b7; /* Gecko Browsers */
      }
    }

    a:active {
      background: black;
      color: white;
      .hitMeText {
        animation: none;
        opacity: 1;
        color: white;
      }
    }

    @include desktop {
      a:hover {
        background: black;
        color: white;
        .hitMeText {
          animation: none;
          opacity: 1;
          color: white;
        }
      }
      a.hitMe:hover {
        color: $c-white;
        background: black;

        .hitMeText {
          animation: none;
          opacity: 1;
          color: white;
        }
      }
    }

    a.hitMe:active {
      color: $c-white;
      background: black;

      .hitMeText {
        animation: none;
        opacity: 1;
        color: white;
      }
    }

    .hitMeText {
      animation: blink 0.4s infinite;
    }

    @keyframes blink {
      0% {
        opacity: 0;
      }
      49% {
        opacity: 0;
      }
      50% {
        opacity: 1;
      }
      100% {
        opacity: 1;
      }
    }

    .hitMe {
      background: white;
      border: solid 2px black;
    }
  }

  footer {
    text-align: center;
    background-color: black;
    color: white;
    padding: 35px 0;
    z-index: 9999;

    a {
      color: white;
      text-decoration: none;
      font-weight: bold;
    }

    > p {
      margin: 0.1rem 0;
    }

    .links {
      margin-top: 1rem;

      a {
        margin-left: 1rem;

        &:first-of-type {
          margin-left: 0;
        }
      }
    }
  }
}
</style>
